<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-row>
      <v-col cols="12">
        <header-big :title="$t('Headers.reset_password')" />
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6">
        <v-card class="elevation-12">
          <v-card-text>
            <v-form>
              <v-text-field
                :label="$t('ResetPage.new_password')"
                prepend-icon="mdi-lock"
                v-model="user.password"
                type="password"
              ></v-text-field>
              <v-text-field
                :label="$t('ResetPage.confirm_new_password')"
                prepend-icon="mdi-lock"
                v-model="user.confirmPassword"
                type="password"
              ></v-text-field>
              <p>
                <custom-button
                  v-bind:block="true"
                  :loading="loading"
                  @click="reset"
                  :text="$t('Headers.reset_password')"
                />
              </p>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "../../i18n";
import CustomButton from "../../components/ui/input/CustomButton";
import HeaderBig from "../../components/ui/text/HeaderBig";
import { log } from "@/helpers/logger";

export default {
  name: "Login",
  title: i18n.t("Headers.reset_password"),
  components: {
    CustomButton,
    HeaderBig,
  },
  data() {
    return {
      user: {
        password: "",
        confirmPassword: "",
      },
      mainColor: "",
    };
  },
  created() {
    this.mainColor = "#d2d1d1";
  },
  methods: {
    reset() {
      this.$store
        .dispatch("auth/reset", {
          user: this.user,
          query: this.$route.query,
        })
        .then(() => {
          log(
            "ResetPage.index.reset() - reset password for " + this.user.id,
            "info"
          );
          this.$router.push("/login");
        })
        .catch((err) => {
          log("ResetPage.index.reset() - " + err, "error");
        });
    },
  },
};
</script>
